import styled from "styled-components";

export type StyledListItemCellProps = {
  width: string;
  align?: "left" | "center" | "right";
};

export const StyledListHeaderItem = styled.div<StyledListItemCellProps>`
  width: ${({ width }) => width};
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  align-items: ${(props) => props.align};
`;
